<h2>MSN Fields</h2>
<div class="cf">
    <div *ngFor="let field of msnFields">
        <label>{{field.category}}</label>
        <select [(ngModel)]="field.selectedOption" 
                (ngModelChange)="onOptionChange(field, $event)"
                [disabled]="!(!slideshow.locked && userCanEdit)">
            <option *ngFor="let option of field.options" [value]="option">
                {{option}}
            </option>
        </select>
    </div>
</div>